import styled from 'styled-components'

export const Wrap = styled('div')`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
`
